/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATION } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationListsMethods extends IPluginMethodMap {
  getPresentationListsProps(args: any): Promise<any>;
}

export class PresentationListsService implements IAgentPlugin {
  readonly methods: IPresentationListsMethods;

  constructor() {
    this.methods = {
      getPresentationListsProps: this.getPresentationListsProps.bind(this),
    };
  }

  async getPresentationListsProps() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATION,
          variables: {
            filter: {
              // year: {
              //   eq: "2024",
              // },
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        let presentationCostumeType = res?.data?.getPresentations;
        console.log("Presentation type========", presentationCostumeType);

        return {
          presentationLists: this.transformData(
            res?.data?.getPresentations?.content,
          ),
          presentationEntireData: res?.data?.getPresentations?.content,
          costumeType: this.transfromCostumeType(
            res?.data?.getPresentations?.content,
          ),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private transfromCostumeType(data: any) {
    console.log("transformCOstumeType", data);
    return data;
  }
  private transformData(inputData: any) {
    return inputData.map((item: any) => {
      return {
        id: item?.id,
        name: item?.name,
        status: item?.status || "active",
        sections: item?.sections.map((section: any) => {
          return {
            id: section?.id,
            name: section?.name,
          };
        }),
      };
    });
  }
}
